exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card .card-block[data-v-1565527c] {\n    background-color:white!important;\n    border:1px solid #e3e3e3!important;\n    border-radius:4px!important;\n    border-top:0px!important;\n}\n.card .card-header[data-v-1565527c] {\n    background-color:#b51663!important;\n    color:white!important;\n}\n.card .card-block *[data-v-1565527c] {\n    color:#444!important;\n}\n", ""]);

// exports
